import { NavigationExtras } from '@angular/router';

export const ROUTE_PATHS = {
    ROOT_PATH: 'classes/:classId/assignments/:assignmentId/item/:itemId/:itemVersion',
    CLASS_SUMMARY: 'classSummary',
    STUDENT_REPORT: 'studentReport',
    SCALE_SCORE: 'scaleScore',
    METRIC: 'metric',
    SEARCH_VIEWER: 'search-viewer',
    MSDA_REPORT_LOADER: 'classes/:classId/assignments/:assignmentId/item/:itemId/:itemVersion/msda-report-loader',
};

export const METRIC_STUDENT_REPORT_ROUTE = `../../${ROUTE_PATHS.STUDENT_REPORT}/${ROUTE_PATHS.METRIC}`;
export const SCALE_SCORE_STUDENT_REPORT_ROUTE = `../../${ROUTE_PATHS.STUDENT_REPORT}/${ROUTE_PATHS.SCALE_SCORE}`;

export const DEFAULT_NAVIGATION_EXTRAS: Partial<NavigationExtras> = {
    queryParamsHandling: 'merge',
};
